import {ROP_MIN_LABEL} from "@/properties.js";

export function getLabel(key) {
	switch (key) {
		case "plant":
			return "Plant";
		case "plant_location":
			return "Location";
		case "plant_price":
			return "Plant Price";
		case "label":
			return "";
		case "bin_location":
			return "Bin Location";
		case "unit":
			return "UOM";
		case "plant_stock":
			return "Stock on Hand";
		case "stock_level":
			return "Stock on Hand";
		case "surplus_level":
			return "Surplus";
		case "rop":
			return ROP_MIN_LABEL;
		case "lot_size":
			return "Lot Size";
		case "rounding_value":
			return "Rounding Value";
		case "max":
			return "MAX";
		case "mrp_type":
			return "MRP Type";
		case "lead_time":
			return "Lead Time (days)";
		case "source":
			return "Source";
		case "cl_name":
			return "Material class";
		case "attrs":
			return "Attributes";
		case "image":
			return "Image";
		case "part_number":
			return "Part Number";
		case "score":
			return "Score";
		case "material":
			return "Material Number";
		case "manufacturer":
			return "Manufacturer";
		case "commonality":
			return "Potential Duplicates";
		case "plant_location_inpex":
			return "SLOC";
		case "purchasing_group":
			return "Purchasing Group";
		case "mrp_controller":
			return "MRP Controller";
		case "last_review_date":
			return "Last Review Date";
		case "criticality":
			return "ABC Indicator";
		case "critical_part":
			return "Critical Part";
		case "client_level":
			return "Client MS";
		case "matl_status":
			return "Plant MS";
		case "valuation_type":
			return "Valuation Type";
		case "pdt":
			return "PDT";
		case "mat_type":
			return "Material Type";
		case "val_type":
			return "Val Type";
		case "batch_number":
			return "Batch#";
		case "special_stock_type":
			return "Spec Stock Type";
		case "wbs_element":
			return "WBS Element";
		case "stock_type":
			return "Stock Type";
		case "price":
			return "Plant Price";
		case "currency":
			return "Currency";
		case "jv":
			return "JV";
		case "plant_stock_level":
			return "Total SoH";
		case "plant_1001":
			return "1001 SoH";
		case "plant_project_stock":
			return "Project SoH";
	}
	return key;
}
